module.exports = __webpack_public_path__ + "img/ar.158defd4.png";